import { render, staticRenderFns } from "./GroupChatEditor.vue?vue&type=template&id=a167678e&scoped=true&"
import script from "./GroupChatEditor.vue?vue&type=script&lang=js&"
export * from "./GroupChatEditor.vue?vue&type=script&lang=js&"
import style0 from "./GroupChatEditor.vue?vue&type=style&index=0&id=a167678e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a167678e",
  null
  
)

export default component.exports